import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { authInterceptor } from 'core/interceptors/auth.interceptor';
import { providePlatformQuillConfig } from 'ui/rich-text-editor/rich-text-editor.config';
import { provideFocusFirstInvalidField } from 'shared/utils/focus-first-invalid-field.util';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([authInterceptor])),
    providePlatformQuillConfig(),
    provideFocusFirstInvalidField(),
  ],
};
